import React from 'react'

export class Nothing extends React.Component {
  render() {
    return null
  }
}

export default Nothing